import { InjectionKey } from 'vue';

import { FileSystemInterface, Folder } from 'SharedDir/declarations/filesystem';

export const Colors = [
  // hsl(330, 60%, 55%)
  {
    saturation: 330,
    lightness: 60,
    alpha: 55,
  },
  // hsl(99, 46%, 49%)
  {
    saturation: 99,
    lightness: 46,
    alpha: 49,
  },
  // hsl(296, 45%, 47%)
  {
    saturation: 296,
    lightness: 45,
    alpha: 47,
  },
  // hsl(147, 43%, 56%)
  {
    saturation: 147,
    lightness: 43,
    alpha: 56,
  },
  // hsl(294, 62%, 67%)
  {
    saturation: 294,
    lightness: 62,
    alpha: 67,
  },
  // hsl(55, 44%, 50%)
  {
    saturation: 55,
    lightness: 44,
    alpha: 50,
  },
  // hsl(246, 55%, 61%)
  {
    saturation: 246,
    lightness: 55,
    alpha: 61,
  },
  // hsl(34, 70%, 53%)
  {
    saturation: 34,
    lightness: 70,
    alpha: 53,
  },
  // hsl(223, 46%, 58%)
  {
    saturation: 223,
    lightness: 46,
    alpha: 58,
  },
  // hsl(14, 65%, 49%)
  {
    saturation: 14,
    lightness: 65,
    alpha: 49,
  },
  // hsl(192, 61%, 55%)
  {
    saturation: 192,
    lightness: 61,
    alpha: 55,
  },
  // hsl(351, 63%, 54%)
  {
    saturation: 351,
    lightness: 63,
    alpha: 54,
  },
  // hsl(148, 43%, 36%)
  {
    saturation: 148,
    lightness: 43,
    alpha: 36,
  },
  // hsl(302, 41%, 69%)
  {
    saturation: 302,
    lightness: 41,
    alpha: 69,
  },
  // hsl(78, 42%, 35%)
  {
    saturation: 78,
    lightness: 42,
    alpha: 35,
  },
  // hsl(312, 30%, 46%)
  {
    saturation: 312,
    lightness: 30,
    alpha: 46,
  },
  // hsl(33, 55%, 37%)
  {
    saturation: 33,
    lightness: 55,
    alpha: 37,
  },
  // hsl(349, 64%, 69%)
  {
    saturation: 349,
    lightness: 64,
    alpha: 69,
  },
  // hsl(21, 63%, 64%)
  {
    saturation: 21,
    lightness: 63,
    alpha: 64,
  },
  // hsl(358, 36%, 47%)
  {
    saturation: 358,
    lightness: 36,
    alpha: 47,
  },
];

export enum FsView {
  tile = 'tile',
  table = 'table',
}

export enum Modes {
  create = 'create',
  update = 'update',
}

export const ServiceKey = Symbol('File System injection key') as InjectionKey<
  FileSystemInterface<Folder>
>;
